var exports = {
  "kL": "x2b2fbebb--673843--container",
  "Qs": "x2b2fbebb--673843--content",
  "Sl": "x2b2fbebb--673843--image",
  "h_": "x2b2fbebb--673843--description",
  "ne": "x2b2fbebb--673843--controls",
};

module.exports = exports;
